
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/samarbeten",
      function () {
        return require("private-next-pages/samarbeten.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/samarbeten"])
      });
    }
  